import 'react-toastify/dist/ReactToastify.css';

import WorkStreamModal from '@/pages/DealspaceDirectory/components/Modal/WorkStreamModal';
import { ListItemButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Icons } from '../../../assets/SvgIcons';
import { ComponentHelper, useEffectAsync } from '../../../helper/Infra';
import {
  InvitetoDealComponents,
  ISDealspaceDirectory,
  MergefloDealspaceUsers,
} from '../../../helper/Interfaces';
import { FunctionalArea } from '../../../pages/authentication/CreateDealspace';
import { getAssets } from '../../../store/feature/assetsSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import classes from './Navigation.module.css';
import { SelectedInvitetoDealItem } from '@/pages/DealspaceDirectory/model';
import PersonModal from '@/pages/DealspaceDirectory/components/Modal/PersonModal';
import { toast } from 'react-toastify';
import { CoreServices } from '@Helper/CoreServices';
import {
  getPlayBookDetail,
  postUserList,
} from '@Store/feature/playBookDetailSlice';
import { getdirectoryDetail } from '@Store/feature/directory';
import {
  getPricingType,
  postShowTrialEndModal,
} from '@Store/feature/pricingSlice';

type props = {
  setRefresh: (refresh: boolean) => void;
  refresh: boolean;
};

export default function CreatePlaybook(props: props) {
  const { refresh } = props;
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const coreService = new CoreServices();
  const { userList } = useAppSelector(getPlayBookDetail);
  const dealspaceDirectoryList = useAppSelector(getdirectoryDetail);
  const currentUser = localStorage.getItem('useremail') ?? '';
  const { functionalAreas, playbooks } = useAppSelector(getAssets);
  const [assetFunctionalAreaCollection, setAssetFunctionalAreaCollection] =
    useState(functionalAreas);
  const [openNewFunctionDialog, setOpenNewFunctionDialog] =
    useState<boolean>(false);
  const [currentInviteToDealComponents, setCurrentinviteToDealComponents] =
    useState<InvitetoDealComponents[]>([]);
  const [inviteToDealComponents, setinviteToDealComponents] = useState<
    InvitetoDealComponents[]
  >([]);
  const [isImo, setIsImo] = useState(false);
  const [workStreamPerson, setWorkStreamPerson] =
    useState<SelectedInvitetoDealItem | null>(null);
  const [workspaceUserList, setWorkspaceUserList] =
    React.useState<MergefloDealspaceUsers[]>(userList);
  const handleClose = () => {
    setOpen(false);
    setNextPage(false);
  };
  const [, setNextPage] = useState(false);
  const componentHelper = new ComponentHelper();
  const [, setDealspaceDirectoryList] = useState<ISDealspaceDirectory[]>([]);
  const dispatch = useAppDispatch();
  const pricingReducer = useAppSelector(getPricingType);
  const isTrialEnd = componentHelper.isDealspaceTrialEnd(pricingReducer);

  useEffectAsync(async () => {
    if (id && dealspaceDirectoryList?.length) {
      setDealspaceDirectoryList(dealspaceDirectoryList);
    }
  }, [id, dealspaceDirectoryList]);

  useEffect(() => {
    const data = functionalAreas?.map((i, index) => {
      return {
        playbookId: i.playbookId,
        playbookName: i.name,
        functionalAreaName: i.name,
        functionalAreaId: i.playbookId,
        user: [],
        index: index,
        color: i.color,
      } as InvitetoDealComponents;
    });
    setCurrentinviteToDealComponents(data ?? []);
    setAssetFunctionalAreaCollection(functionalAreas);
  }, [functionalAreas]);

  useEffectAsync(async () => {
    let directory = [] as ISDealspaceDirectory[];
    const alphabet = [
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'x',
      'y',
      'z',
      'ı',
      'ü',
      'ö',
      'ç',
      'ş',
    ];

    if (id) {
      const dsdlist = Object.assign(
        [],
        dealspaceDirectoryList as ISDealspaceDirectory[]
      );
      directory = [...dsdlist];
    }

    const list = [...(functionalAreas?.filter(area => area.dealspaceId) || [])];
    const imoSpace = [...(functionalAreas?.filter(i => i.isIMO) || [])];

    setWorkspaceUserList(userList);

    let currentInviteToDeals = [] as InvitetoDealComponents[];
    for (const item of imoSpace) {
      currentInviteToDeals.push({
        functionalAreaName: item.name,
        functionalAreaId: item.id,
        playbookId: '',
        index: -1,
        user: [],
        playbookName: '',
        color: item.color,
      });
    }
    for (const item of list) {
      currentInviteToDeals.push({
        functionalAreaName: item.name,
        functionalAreaId: item.id,
        playbookId: '',
        index: 1,
        user: [],
        playbookName: '',
        color: item.color,
      });
    }
    for (const user of userList) {
      let alreadyIncludedComponent = currentInviteToDeals.filter(
        c => c.functionalAreaId === user.functionalAreaId
      );
      if (alreadyIncludedComponent.length > 0) {
        alreadyIncludedComponent[0].playbookId = user.playbookId;
        alreadyIncludedComponent[0].user.push({
          companyRole: user.companyRole,
          inviteStatus: user.inviteStatus,
          name: user.name,
          phone: user.phone,
          playbookId: user.playbookId,
          surname: user.surname,
          username: user.username,
          userRole: user.userRole,
          userStatus: user.userStatus,
          projectUserId: user.projectUserId ?? '',
          createdAt: '',
          inviteDate: user.inviteDate ?? '',
        });
      } else {
        currentInviteToDeals.push({
          functionalAreaName: user.functionalArea,
          functionalAreaId: user.functionalAreaId,
          color: list.find(i => i.id === user.functionalAreaId)?.color ?? '',
          playbookId: user.playbookId,
          playbookName: user.playbookName,
          index:
            user.functionalArea === 'Integration Management Office'
              ? -1
              : alphabet.includes(user.functionalArea[0].toLocaleLowerCase())
              ? alphabet.indexOf(user.functionalArea[0].toLocaleLowerCase())
              : 1,
          user: [
            {
              projectUserId: user.projectUserId ?? '',
              companyRole: user.companyRole,
              inviteStatus: user.inviteStatus,
              name: user.name,
              phone: user.phone,
              playbookId: user.playbookId,
              surname: user.surname,
              username: user.username,
              userRole: user.userRole,
              userStatus: user.userStatus,
              createdAt: '',
              inviteDate: user.inviteDate ?? '',
            },
          ],
        });
      }
    }
    for (const item of directory) {
      if (!item.playbookId) {
        let alreadyIncludedComponent = currentInviteToDeals.find(
          c => c.functionalAreaId === item.functionalAreaId
        );
        if (
          alreadyIncludedComponent !== undefined &&
          alreadyIncludedComponent.user.find(
            f => f.username === item.username
          ) === undefined
        ) {
          alreadyIncludedComponent.user.push({
            companyRole: item.companyRole ?? '',
            inviteStatus: 'waiting',
            dealspaceUserId: item.dealspaceUserId ?? '',
            name: item.name ?? '',
            phone: item.phone ?? '',
            playbookId: alreadyIncludedComponent.playbookId,
            surname: item.surname ?? '',
            username: item.username,
            userRole: item.companyRole ?? '',
            userStatus: 'invited',
            createdAt: item.createdAt ?? '',
            inviteDate: item.inviteDate ?? '',
          });
        }
      }
    }
    setinviteToDealComponents(currentInviteToDeals);
    setCurrentinviteToDealComponents(currentInviteToDeals);

    const hasImoWorkspace = currentInviteToDeals.find(
      i => i.functionalAreaId === functionalAreas?.find(a => a.isIMO)?.id
    );

    if (hasImoWorkspace) {
      if (
        hasImoWorkspace.user.filter(i => i.username === currentUser).length > 0
      ) {
        setIsImo(true);
      } else {
        setIsImo(false);
      }
    } else {
      setIsImo(false);
    }
  }, [userList, functionalAreas, assetFunctionalAreaCollection]);

  const addWorkStreamPersonModalOpen = (
    selectInvitetoDeal: InvitetoDealComponents
  ) => {
    // setWorkStreamPerson({
    //   item: selectInvitetoDeal,
    //   operation: 'addWp',
    // });
  };

  const sendInvitation = async (
    newUserEmail: string[],
    newUserMessage: string,
    newUserFunctionalId: string
  ) => {
    let isTeammate = false;
    if (newUserEmail.length < 1) {
      toast('Please enter the email');
      return;
    }

    const functionalArea = inviteToDealComponents.find(
      i => i.functionalAreaId === newUserFunctionalId
    );
    if (
      functionalArea &&
      functionalArea.user.filter(u => u.userRole === 'owner').length > 0
    ) {
      isTeammate = true;
    }
    if (isTeammate) {
      if (!newUserEmail) {
        toast('Please enter a valid email');
        return;
      }
      if (!functionalArea) {
        return;
      }
      coreService
        .inviteProject(newUserEmail, functionalArea.playbookId, newUserMessage)
        .catch(err => {
          toast(err?.message ?? 'Something has wrong, please try again later');
        })
        .then(async resp => {
          console.log('resp', resp);
          if (resp.message) {
            toast(resp.message);
          } else {
            const newElem = Object.assign(
              functionalArea
            ) as InvitetoDealComponents;
            const oldInvitetoDealSpaceElement = [
              ...inviteToDealComponents.filter(
                i => i.functionalAreaId !== functionalArea.functionalAreaId
              ),
            ];

            for (const respData of resp.data) {
              newElem.user.push({
                companyRole: respData.companyRole ?? '',
                createdAt: respData.createdAt,
                inviteStatus: respData.inviteStatus,
                name: '',
                surname: '',
                phone: '',
                playbookId: functionalArea.playbookId,
                username: respData.username,
                userRole: respData.userRole,
                userStatus: respData.userStatus,
                projectUserId: respData.id,
                inviteDate: respData.inviteDate,
              });
              oldInvitetoDealSpaceElement.push(newElem);
            }

            setinviteToDealComponents(oldInvitetoDealSpaceElement);
            setCurrentinviteToDealComponents(oldInvitetoDealSpaceElement);
            setWorkStreamPerson(null);
            toast('Successfully Invited');
          }
        });

      setWorkStreamPerson(null);
      return;
    }
    const data = await componentHelper.createDealspaceUser(
      id ?? '',
      newUserEmail,
      newUserFunctionalId,
      newUserMessage
    );
    console.log('data', data);
    if (data?.errorCode && data?.errorCode !== '') {
      console.log('here');
      toast.error(data?.message, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      });

      return;
    }
    if (![201, 200].includes(data?.status)) {
      toast('Error ' + data.message);
      return;
    }
    toast('Successfully invited');
    setOpenNewFunctionDialog(false);
    const newCreated = data.data;
    newCreated.dealspaceUserId = data.data.id;

    setDealspaceDirectoryList(old => [...old, newCreated]);
    setWorkStreamPerson(null);
  };

  return (
    <>
      {refresh ? (
        <ListItemButton
          className={classes.addNewPlaybook}
          style={{ marginLeft: 24 }}
          onClick={() => {
            if (isTrialEnd) {
              dispatch(postShowTrialEndModal(true));
              return;
            }
            setOpen(true);
          }}
        >
          <>
            <div className={classes.addNewPlaybookIcon}>
              <Icons.Add color="#7D7A9A" />
            </div>
            <span> ADD WORKSTREAM</span>
          </>
        </ListItemButton>
      ) : (
        <ListItemButton
          className={classes.addNewPlaybookMinimized}
          onClick={() => setOpen(true)}
        >
          <Icons.Add color="#7D7A9A" />
        </ListItemButton>
      )}

      {open && (
        <WorkStreamModal
          onClose={handleClose}
          selectedWorkStream={null}
          //currentInviteToDealComponents={currentInviteToDealComponents}
          // setAddWorkStreams={addWorkStreamPersonModalOpen}
        />
      )}

      {workStreamPerson && (
        <PersonModal
          onClose={() => {
            setWorkStreamPerson(null);
          }}
          selectedWorkStream={workStreamPerson}
        />
      )}
    </>
  );
}
